function trimLeadingZeroes(value: string) {
  return value.replace(/^0+/, '')
}

export default trimLeadingZeroes
